import { render, staticRenderFns } from "./zhusuDetail.vue?vue&type=template&id=4704316c&scoped=true&"
import script from "./zhusuDetail.vue?vue&type=script&lang=js&"
export * from "./zhusuDetail.vue?vue&type=script&lang=js&"
import style0 from "./zhusuDetail.vue?vue&type=style&index=0&id=4704316c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704316c",
  null
  
)

export default component.exports